(function(){if(window.coastalMobilePurchaseBarVisibilityV3)return;window.coastalMobilePurchaseBarVisibilityV3=!0;var mq=window.matchMedia("(max-width: 699px)"),scheduled=!1;function button(){return document.querySelector('.shopify-section--main-product product-form buy-buttons button[type="submit"]')}function bar(){return document.querySelector(".coastal-mobile-purchase-bar")}function sync(){scheduled=!1;var x=bar(),b=button();if(!(!x||!b)){var show=mq.matches&&b.getBoundingClientRect().bottom<=72;x.hidden=!show,document.body.classList.toggle("coastal-has-mobile-purchase-bar",show)}}function schedule(){scheduled||(scheduled=!0,window.requestAnimationFrame(sync))}function connect(){schedule()}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",connect,{once:!0}):connect(),window.addEventListener("scroll",schedule,{passive:!0}),window.addEventListener("resize",schedule,{passive:!0}),mq.addEventListener&&mq.addEventListener("change",schedule),document.addEventListener("shopify:section:load",connect),new MutationObserver(connect).observe(document.documentElement,{childList:!0,subtree:!0})})(),(()=>{if(window.coastalRegularPriceA11yV1)return;window.coastalRegularPriceA11yV1=!0;const syncPriceLabels=(root=document)=>{root.querySelectorAll("price-list").forEach(priceList=>{const label=priceList.querySelector("sale-price")?.querySelector(".sr-only"),hasCompareAtPrice=!!priceList.querySelector("compare-at-price");label&&!hasCompareAtPrice&&/^sale price$/i.test(label.textContent.trim())&&(label.textContent="Price")})},connect=()=>syncPriceLabels();document.readyState==="loading"?document.addEventListener("DOMContentLoaded",connect,{once:!0}):connect(),document.addEventListener("shopify:section:load",connect),new MutationObserver(connect).observe(document.documentElement,{childList:!0,subtree:!0})})(),(()=>{if(window.coastalDesignConsultationPathwayV1)return;window.coastalDesignConsultationPathwayV1=!0;const designHelpUrl="/pages/design-help",contactUrl="/pages/contact?topic=design-help",ensureStyles=()=>{if(document.getElementById("coastal-design-consultation-pathway-v1-styles"))return;const style=document.createElement("style");style.id="coastal-design-consultation-pathway-v1-styles",style.textContent=`
      .coastal-design-pathway__link {
        display: inline-flex;
        align-items: center;
        gap: .45rem;
        margin-top: .85rem;
        color: currentColor;
        font-size: .92rem;
        font-weight: 650;
        line-height: 1.35;
        text-decoration: none;
        border-bottom: 1px solid currentColor;
        padding-bottom: .18rem;
      }
      .coastal-design-pathway__link:hover,
      .coastal-design-pathway__link:focus-visible {
        opacity: .72;
      }
      .coastal-design-pathway__cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 46px;
        margin-top: 1.25rem;
        padding: .8rem 1.25rem;
        border: 1px solid #272522;
        background: #272522 !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff;
        font-size: .92rem;
        font-weight: 650;
        line-height: 1.2;
        text-decoration: none;
        transition: background-color .2s ease, color .2s ease;
      }
      .coastal-design-pathway__cta:hover,
      .coastal-design-pathway__cta:focus-visible {
        background: #eee9e1 !important;
        color: #272522 !important;
        -webkit-text-fill-color: #272522;
      }
      .coastal-design-contact-intro {
        max-width: 780px;
        margin: 0 auto 2rem;
        padding: clamp(1.25rem, 3vw, 2rem);
        background: #eee9e1;
        border: 1px solid rgba(39, 37, 34, .14);
      }
      .coastal-design-contact-intro__eyebrow {
        margin: 0 0 .55rem;
        font-size: .76rem;
        font-weight: 700;
        letter-spacing: .13em;
        text-transform: uppercase;
      }
      .coastal-design-contact-intro h2 {
        margin: 0 0 .65rem;
        font-size: clamp(1.5rem, 3vw, 2.15rem);
        line-height: 1.12;
      }
      .coastal-design-contact-intro p:last-child {
        margin-bottom: 0;
      }
      .coastal-design-pathway__decision-card {
        margin-top: 1rem;
        padding: 1rem 1.1rem;
        border: 1px solid rgba(39, 37, 34, .18);
        background: #f4f0e9;
        color: #272522;
      }
      .coastal-design-pathway__decision-card p {
        margin: 0;
      }
      .coastal-design-pathway__decision-card-title {
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.35;
      }
      .coastal-design-pathway__decision-card-copy {
        margin-top: .35rem !important;
        font-size: .88rem;
        line-height: 1.5;
        opacity: .82;
      }
      .coastal-design-pathway__decision-card .coastal-design-pathway__link {
        margin-top: .7rem;
      }
      .coastal-design-pathway__cart-card {
        max-width: 680px;
        margin: 1.25rem auto 0;
        text-align: center;
      }
      .coastal-design-pathway__steps {
        margin: clamp(2rem, 5vw, 3.5rem) 0;
        padding: clamp(1.4rem, 4vw, 2.4rem);
        background: #eee9e1;
        border: 1px solid rgba(39, 37, 34, .14);
      }
      .coastal-design-pathway__steps h2 {
        margin: 0 0 1.25rem;
        font-size: clamp(1.5rem, 3vw, 2.1rem);
        line-height: 1.15;
      }
      .coastal-design-pathway__step-list {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1.25rem;
        margin: 0;
        padding: 0;
        list-style: none;
      }
      .coastal-design-pathway__step-number {
        display: block;
        margin-bottom: .45rem;
        font-size: .74rem;
        font-weight: 700;
        letter-spacing: .12em;
      }
      .coastal-design-pathway__step-list strong {
        display: block;
        margin-bottom: .35rem;
        font-size: 1rem;
      }
      .coastal-design-pathway__step-list p {
        margin: 0;
        font-size: .9rem;
        line-height: 1.55;
      }
      .coastal-design-pathway__nav-item a[aria-current="page"] {
        text-decoration: underline;
        text-underline-offset: .3em;
      }
      .coastal-design-form-details {
        margin-top: 1.25rem;
        padding-top: 1.25rem;
        border-top: 1px solid rgba(39, 37, 34, .16);
      }
      .coastal-design-form-details h3 {
        margin: 0 0 .35rem;
        font-size: 1.15rem;
      }
      .coastal-design-form-details__note {
        margin: 0 0 1rem;
        font-size: .86rem;
        opacity: .72;
      }
      .coastal-design-form-details__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
      }
      .coastal-design-form-field {
        display: grid;
        gap: .4rem;
      }
      .coastal-design-form-field--wide {
        grid-column: 1 / -1;
      }
      .coastal-design-form-field label {
        font-size: .82rem;
        font-weight: 650;
      }
      .coastal-design-form-field .input,
      .coastal-design-form-field select {
        width: 100%;
        min-height: 48px;
        padding: .75rem;
        border: 1px solid rgba(39, 37, 34, .28);
        background: #fff;
        color: #272522;
      }
      .coastal-design-success {
        max-width: 780px;
        margin: 0 auto 2rem;
        padding: clamp(1.25rem, 3vw, 2rem);
        border: 1px solid rgba(39, 37, 34, .18);
        background: #eee9e1;
      }
      .coastal-design-success h2 {
        margin: 0 0 .55rem;
        font-size: clamp(1.45rem, 3vw, 2rem);
      }
      .coastal-design-success p:last-child {
        margin-bottom: 0;
      }
      @media (max-width: 699px) {
        .coastal-design-pathway__cta {
          width: 100%;
        }
        .coastal-design-contact-intro {
          margin-bottom: 1.5rem;
        }
        .coastal-design-pathway__step-list {
          grid-template-columns: 1fr;
        }
        .coastal-design-form-details__grid {
          grid-template-columns: 1fr;
        }
        .coastal-design-form-field--wide {
          grid-column: auto;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .coastal-design-pathway__cta {
          transition: none;
        }
      }
    `,document.head.appendChild(style)},enhanceHomepage=()=>{if(window.location.pathname!=="/")return;const container=[...document.querySelectorAll("main p")].find(item=>item.textContent.trim()==="Design Help")?.parentElement;if(!container||container.querySelector('[data-coastal-design-pathway="home"]'))return;const link=document.createElement("a");link.href=designHelpUrl,link.className="coastal-design-pathway__link",link.dataset.coastalDesignPathway="home",link.textContent="Start your design conversation \u2192",container.appendChild(link)},enhancePrimaryNavigation=()=>{document.querySelectorAll('nav[aria-label="Primary navigation"]').forEach(nav=>{const list=nav.querySelector(":scope > ul");if(!list||list.querySelector('[data-coastal-design-pathway="navigation"]'))return;const item=document.createElement("li");item.className="header__primary-nav-item coastal-design-pathway__nav-item",item.dataset.coastalDesignPathway="navigation";const link=document.createElement("a");link.href=designHelpUrl,link.className="block h6",link.dataset.title="Design Help",link.textContent="Design Help",window.location.pathname===designHelpUrl&&link.setAttribute("aria-current","page"),item.appendChild(link);const sale=[...list.children].find(child=>child.querySelector('a[href="/collections/sale"]'));list.insertBefore(item,sale||null)})},enhanceDesignHelpPage=()=>{if(window.location.pathname!==designHelpUrl)return;const main=document.querySelector("main");if(!main)return;const intro=[...main.querySelectorAll("p")].find(item=>item.textContent.trim().startsWith("Choosing furniture from a large catalog"));if(intro&&!main.querySelector('[data-coastal-design-pathway="intro"]')){const topCta2=document.createElement("a");topCta2.href=contactUrl,topCta2.className="coastal-design-pathway__cta",topCta2.dataset.coastalDesignPathway="intro",topCta2.textContent="Start your design conversation",intro.insertAdjacentElement("afterend",topCta2)}const topCta=main.querySelector('[data-coastal-design-pathway="intro"]');if(topCta&&!main.querySelector('[data-coastal-design-pathway="steps"]')){const steps=document.createElement("section");steps.className="coastal-design-pathway__steps",steps.dataset.coastalDesignPathway="steps",steps.setAttribute("aria-labelledby","coastal-design-steps-heading"),steps.innerHTML=`
        <h2 id="coastal-design-steps-heading">How design help works</h2>
        <ol class="coastal-design-pathway__step-list">
          <li>
            <span class="coastal-design-pathway__step-number">01</span>
            <strong>Share the room</strong>
            <p>Send approximate measurements, photographs, inspiration and links to pieces you are considering.</p>
          </li>
          <li>
            <span class="coastal-design-pathway__step-number">02</span>
            <strong>Compare the options</strong>
            <p>We help you consider scale, configuration, materials and how the pieces work together.</p>
          </li>
          <li>
            <span class="coastal-design-pathway__step-number">03</span>
            <strong>Move forward clearly</strong>
            <p>Use the guidance to make a more informed decision before placing your order.</p>
          </li>
        </ol>
      `,topCta.insertAdjacentElement("afterend",steps)}const finalCta=[...main.querySelectorAll('a[href="/pages/contact"]')].find(link=>link.textContent.trim()==="Contact Coastal Design Studio");finalCta&&(finalCta.href=contactUrl,finalCta.classList.add("coastal-design-pathway__cta"),finalCta.dataset.coastalDesignPathway="final",finalCta.textContent="Tell us about your room")},emitConsultationEvent=(eventName,detail={})=>{const payload={event:eventName,pathway:"design-consultation",page_path:window.location.pathname,...detail};document.dispatchEvent(new CustomEvent("coastal:design-consultation",{detail:payload})),Array.isArray(window.dataLayer)&&window.dataLayer.push(payload)},ensureConsultationTracking=()=>{window.coastalDesignConsultationTrackingV1||(window.coastalDesignConsultationTrackingV1=!0,document.addEventListener("click",event=>{const link=event.target.closest("a"),source=link?.closest("[data-coastal-design-pathway]");!link||!source||!link.href.includes("/pages/design-help")&&!link.href.includes("topic=design-help")||emitConsultationEvent("design_consultation_cta_click",{source:source.dataset.coastalDesignPathway||"unknown"})}))},enhanceContactPage=()=>{if(window.location.pathname!=="/pages/contact")return;const main=document.querySelector("main"),form=main?.querySelector('form[action="/contact#contact_form"]')||main?.querySelector('form[action*="/contact"]:has(textarea)');if(!main||!form)return;const params=new URLSearchParams(window.location.search),isDesignTopic=params.get("topic")==="design-help",source=params.get("from"),productHandle=params.get("product"),successNotice=[...main.querySelectorAll("*")].find(item=>item.children.length===0&&/^(your message has been sent|thank you.*(?:received|sent))/i.test(item.textContent.trim()));let submittedConsultation=!1;try{submittedConsultation=sessionStorage.getItem("coastal-design-consultation-submitted")==="1"}catch{}if(!isDesignTopic&&!(submittedConsultation&&successNotice))return;if(submittedConsultation&&successNotice&&!main.querySelector(".coastal-design-success")){const confirmation=document.createElement("section");confirmation.className="coastal-design-success",confirmation.setAttribute("role","status"),confirmation.innerHTML=`
        <h2>Your design request is on its way</h2>
        <p>Thank you for sharing your project. Keep any additional room photographs, measurements or product links handy in case they help with the conversation.</p>
      `,successNotice.insertAdjacentElement("afterend",confirmation),emitConsultationEvent("design_consultation_form_success");try{sessionStorage.removeItem("coastal-design-consultation-submitted")}catch{}return}if(!main.querySelector(".coastal-design-contact-intro")){const intro=document.createElement("section");intro.className="coastal-design-contact-intro",intro.setAttribute("aria-labelledby","coastal-design-contact-heading"),intro.innerHTML=`
        <p class="coastal-design-contact-intro__eyebrow">Personal Design Help</p>
        <h2 id="coastal-design-contact-heading">Tell us about your room</h2>
        <p>Share your room measurements, photographs, inspiration images or links to products you are considering. We can help you compare scale, materials and coordination before you order.</p>
      `,form.insertAdjacentElement("beforebegin",intro)}const message=form.querySelector("textarea");message&&(!message.placeholder||message.placeholder==="Message")&&(message.placeholder="Room, approximate measurements, products you like, and what you would like help deciding\u2026");const messageLabel=message?.id?form.querySelector(`label[for="${CSS.escape(message.id)}"]`):null;messageLabel&&(messageLabel.textContent="What would you like help deciding?"),message&&(message.rows=6);const fieldset=form.querySelector(".fieldset"),messageControl=message?.closest(".form-control");if(fieldset&&messageControl&&!form.querySelector(".coastal-design-form-details")){const details=document.createElement("section");details.className="coastal-design-form-details",details.setAttribute("aria-labelledby","coastal-design-details-heading"),details.innerHTML=`
        <h3 id="coastal-design-details-heading">A few project details</h3>
        <p class="coastal-design-form-details__note">Room type is required. The remaining details are optional, but help us understand your project.</p>
        <div class="coastal-design-form-details__grid">
          <div class="coastal-design-form-field">
            <label for="coastal-design-room-type">Room type *</label>
            <select id="coastal-design-room-type" class="input" name="contact[Room type]" required>
              <option value="" selected disabled>Select a room</option>
              <option>Living room</option><option>Dining room</option><option>Bedroom</option>
              <option>Home office</option><option>Outdoor</option><option>Whole-home or multiple rooms</option><option>Other</option>
            </select>
          </div>
          <div class="coastal-design-form-field">
            <label for="coastal-design-dimensions">Approximate room dimensions</label>
            <input id="coastal-design-dimensions" class="input" type="text" name="contact[Room dimensions]" placeholder="For example, 12 ft \xD7 16 ft">
          </div>
          <div class="coastal-design-form-field coastal-design-form-field--wide">
            <label for="coastal-design-products">Products being considered</label>
            <input id="coastal-design-products" class="input" type="text" name="contact[Products being considered]" placeholder="Product names, SKUs or links">
          </div>
          <div class="coastal-design-form-field">
            <label for="coastal-design-contact-method">Preferred contact method</label>
            <select id="coastal-design-contact-method" class="input" name="contact[Preferred contact method]">
              <option>Email</option><option>Phone</option>
            </select>
          </div>
          <div class="coastal-design-form-field">
            <label for="coastal-design-phone">Phone, if preferred</label>
            <input id="coastal-design-phone" class="input" type="tel" name="contact[Phone]" autocomplete="tel" placeholder="Phone number">
          </div>
          <div class="coastal-design-form-field">
            <label for="coastal-design-timing">Project timing</label>
            <select id="coastal-design-timing" class="input" name="contact[Project timing]">
              <option>Still exploring</option><option>Within 1 month</option><option>Within 1\u20133 months</option>
              <option>Within 3\u20136 months</option><option>More than 6 months</option>
            </select>
          </div>
          <div class="coastal-design-form-field">
            <label for="coastal-design-budget">Approximate furniture budget</label>
            <select id="coastal-design-budget" class="input" name="contact[Budget range]">
              <option>Still deciding</option><option>Under $2,500</option><option>$2,500\u2013$5,000</option>
              <option>$5,000\u2013$10,000</option><option>$10,000+</option>
            </select>
          </div>
        </div>
      `,messageControl.insertAdjacentElement("beforebegin",details)}if(!form.querySelector('[data-coastal-design-context="inquiry-type"]')){const inquiryType=document.createElement("input");inquiryType.type="hidden",inquiryType.name="contact[Inquiry type]",inquiryType.value="Design consultation",inquiryType.setAttribute("value","Design consultation"),inquiryType.dataset.coastalDesignContext="inquiry-type",form.appendChild(inquiryType)}if(form.dataset.coastalDesignTracking||(form.dataset.coastalDesignTracking="true",form.addEventListener("submit",()=>{try{sessionStorage.setItem("coastal-design-consultation-submitted","1")}catch{}emitConsultationEvent("design_consultation_form_submit",{source:source||"direct"})})),source==="product"&&productHandle&&/^[a-z0-9-]+$/.test(productHandle)&&!form.querySelector('[data-coastal-design-context="product"]')){const productContext=document.createElement("input");productContext.type="hidden",productContext.name="contact[Product URL]",productContext.value=`${window.location.origin}/products/${productHandle}`,productContext.setAttribute("value",productContext.value),productContext.dataset.coastalDesignContext="product",form.appendChild(productContext)}if(source==="cart"&&!form.querySelector('[data-coastal-design-context="cart"]')){const cartContext=document.createElement("input");cartContext.type="hidden",cartContext.name="contact[Inquiry source]",cartContext.value="Cart",cartContext.setAttribute("value","Cart"),cartContext.dataset.coastalDesignContext="cart",form.appendChild(cartContext)}},enhanceProductPage=()=>{if(!window.location.pathname.startsWith("/products/"))return;const main=document.querySelector("main");if(!main||main.querySelector('[data-coastal-design-pathway="product"]'))return;const productForm=main.querySelector("product-form");if(!productForm)return;const title=main.querySelector("h1")?.textContent.trim()||"this piece",productHandle=window.location.pathname.split("/").filter(Boolean).pop()||"",destination=`${contactUrl}&from=product&product=${encodeURIComponent(productHandle)}`,card=document.createElement("aside");card.className="coastal-design-pathway__decision-card",card.dataset.coastalDesignPathway="product",card.setAttribute("aria-label","Personal design help"),card.innerHTML=`
      <p class="coastal-design-pathway__decision-card-title">Unsure about scale, color or coordination?</p>
      <p class="coastal-design-pathway__decision-card-copy">Ask our team about ${title.replace(/[<>&]/g,"")} before you order.</p>
      <a class="coastal-design-pathway__link" href="${destination}">Ask about this piece \u2192</a>
    `,productForm.insertAdjacentElement("afterend",card)},enhanceCartPage=()=>{if(window.location.pathname!=="/cart")return;const main=document.querySelector("main");if(!main||main.querySelector('[data-coastal-design-pathway="cart"]'))return;const checkoutButton=[...main.querySelectorAll('button, input[type="submit"]')].find(item=>/checkout/i.test(item.textContent||item.value||"")),emptyDirection=[...main.querySelectorAll("a")].find(link=>link.textContent.trim().includes("Explore Inspiration")),anchor=checkoutButton?.closest("form, div")||emptyDirection;if(!anchor)return;const card=document.createElement("aside");card.className="coastal-design-pathway__decision-card coastal-design-pathway__cart-card",card.dataset.coastalDesignPathway="cart",card.setAttribute("aria-label","Design help before ordering"),card.innerHTML=`
      <p class="coastal-design-pathway__decision-card-title">Want a second opinion before ordering?</p>
      <p class="coastal-design-pathway__decision-card-copy">We can help review scale, coordination and fit considerations.</p>
      <a class="coastal-design-pathway__link" href="${contactUrl}&from=cart">Ask for design help \u2192</a>
    `,anchor.insertAdjacentElement("afterend",card)},apply=()=>{ensureStyles(),ensureConsultationTracking(),enhancePrimaryNavigation(),enhanceHomepage(),enhanceDesignHelpPage(),enhanceContactPage(),enhanceProductPage(),enhanceCartPage()};let timer;const schedule=()=>{window.clearTimeout(timer),timer=window.setTimeout(apply,80)};document.readyState==="loading"?document.addEventListener("DOMContentLoaded",apply,{once:!0}):apply(),document.addEventListener("shopify:section:load",schedule),new MutationObserver(schedule).observe(document.documentElement,{childList:!0,subtree:!0})})(),(()=>{if(window.coastalCollectionSearchEditorialGridV1)return;window.coastalCollectionSearchEditorialGridV1=!0;const isCollection=location.pathname.startsWith("/collections/"),isSearch=location.pathname==="/search";if(!isCollection&&!isSearch)return;document.body.classList.add("coastal-grid-commerce");const scenes={living:{image:"https://cdn.shopify.com/s/files/1/1017/5787/8644/files/c4cfa089-a66a-48cd-bb88-04c56e6f469e.jpg?v=1786762044&width=1800",alt:"Light-filled neutral living room with a soft sofa chaise and slim accent tables",eyebrow:"The room, considered",title:"Start with comfort. Leave room for life.",copy:"A strong anchor piece, warm wood and useful surfaces create a room that feels collected without feeling crowded.",href:"/collections/living-room",link:"Explore living room"},dining:{image:"https://cdn.shopify.com/s/files/1/1017/5787/8644/files/1a849f28-91f7-46f9-998d-3b45f47ed1c4.jpg?v=1788219754&width=1800",alt:"Light contemporary dining room with an extendable table and upholstered chairs",eyebrow:"Gather beautifully",title:"Make everyday meals feel considered.",copy:"Balance the table with comfortable seating and flexible storage so the room works for quiet mornings and a fuller house.",href:"/collections/dining-room",link:"Explore dining"},bedroom:{image:"https://cdn.shopify.com/s/files/1/1017/5787/8644/files/c3c0854b-7de7-4f78-a140-ab8b431bdc46.jpg?v=1788219793&width=1800",alt:"Warm neutral bedroom with an upholstered bed, dresser and soft layered textiles",eyebrow:"A quieter point of view",title:"Let texture do the talking.",copy:"Begin with the bed, keep the palette restrained and add only the pieces that make the room calmer and easier to live in.",href:"/collections/bedroom",link:"Explore bedroom"},office:{image:"https://cdn.shopify.com/s/files/1/1017/5787/8644/files/8cfa6660-9e91-4dec-aa1e-e93de903212f.jpg?v=1786739269&width=1800",alt:"Bright home office with a warm wood desk, open bookcase and upholstered chair",eyebrow:"Work, beautifully",title:"Create focus without losing warmth.",copy:"Useful storage and a generous working surface can support the day while still belonging to the rest of your home.",href:"/collections/home-office",link:"Explore home office"},outdoor:{image:"https://cdn.shopify.com/s/files/1/1017/5787/8644/files/730b09ae-ec94-41a0-af49-3f46d52364a8.jpg?v=1786737831&width=1800",alt:"Outdoor dining space surrounded by greenery with a fire pit table and woven seating",eyebrow:"The open-air room",title:"Give gathering a place outside.",copy:"Comfortable seating, a useful center and durable texture turn the patio into a room everyone wants to stay in.",href:"/collections/outdoor",link:"Explore outdoor living"}},context=`${location.pathname} ${new URLSearchParams(location.search).get("q")||""}`.toLowerCase(),room=/outdoor|patio|fire.?pit/.test(context)?"outdoor":/bedroom|mattress|\bbed\b|dresser|nightstand/.test(context)?"bedroom":/dining|stool|bar.?cart|server/.test(context)?"dining":/office|desk|bookcase/.test(context)?"office":"living",scene=scenes[room],style=document.createElement("style");style.id="coastal-collection-search-editorial-grid-v1-styles",style.textContent=`
    .coastal-grid-commerce product-card,.coastal-grid-commerce .product-card{height:100%;color:#242321}
    .coastal-grid-commerce .product-card__figure{position:relative;overflow:hidden;background:#f5f1ea}
    .coastal-grid-commerce .product-card__figure img{transition:transform .55s cubic-bezier(.22,1,.36,1)}
    .coastal-grid-commerce product-card:hover .product-card__figure img,.coastal-grid-commerce .product-card:hover .product-card__figure img{transform:scale(1.018)}
    .coastal-grid-commerce .product-card__info{display:grid;gap:.38rem;padding-top:1rem}
    .coastal-grid-commerce .product-card__title{font-size:clamp(.95rem,1.15vw,1.08rem);font-weight:500;line-height:1.35;letter-spacing:-.01em;text-wrap:balance}
    .coastal-grid-commerce .product-card__info .vendor,.coastal-grid-commerce .product-card__info [class*='vendor']{order:-1;color:#777066;font-size:.66rem;font-weight:650;letter-spacing:.11em;text-transform:uppercase}
    .coastal-grid-commerce .price-list{margin-top:.15rem;font-size:.95rem;font-weight:650;letter-spacing:.01em}
    .coastal-grid-commerce .badge-list{gap:.35rem}
    .coastal-grid-commerce .badge{padding:.36rem .52rem;border-radius:0;background:#fffdf9;color:#38342f;font-size:.62rem;letter-spacing:.08em;box-shadow:0 0 0 1px rgba(36,35,33,.12)}
    .coastal-grid-story{grid-column:1/-1;display:grid;grid-template-columns:minmax(0,1.15fr) minmax(19rem,.85fr);min-height:clamp(24rem,36vw,34rem);margin-block:clamp(2.5rem,5vw,5rem);overflow:hidden;background:#eee8df;color:#242321}
    .coastal-grid-story__media{min-height:100%;overflow:hidden}
    .coastal-grid-story__media img{display:block;width:100%;height:100%;object-fit:cover;transition:transform .75s cubic-bezier(.22,1,.36,1)}
    .coastal-grid-story:hover .coastal-grid-story__media img{transform:scale(1.015)}
    .coastal-grid-story__content{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;padding:clamp(2rem,5vw,5rem)}
    .coastal-grid-story__eyebrow{margin:0 0 .7rem;color:#746d64;font-size:.68rem;font-weight:650;letter-spacing:.14em;text-transform:uppercase}
    .coastal-grid-story h2{max-width:14ch;margin:0;font-family:var(--heading-font-family);font-size:clamp(2rem,3.8vw,3.65rem);font-weight:400;line-height:1.04;letter-spacing:-.035em;text-wrap:balance}
    .coastal-grid-story__copy{max-width:42ch;margin:1.1rem 0 1.5rem;color:#625d56;line-height:1.7}
    .coastal-grid-story__link{display:inline-flex;min-height:44px;align-items:center;border-bottom:1px solid currentColor;color:inherit;font-size:.72rem;font-weight:650;letter-spacing:.1em;text-decoration:none;text-transform:uppercase}
    .coastal-grid-story__link::after{margin-left:.55rem;content:'\u2192'}
    @media(max-width:749px){
      .coastal-grid-commerce .product-card__info{gap:.32rem;padding-top:.75rem}
      .coastal-grid-commerce .product-card__title{font-size:.92rem}
      .coastal-grid-story{grid-template-columns:1fr;min-height:0;margin-inline:0;max-width:100%}
      .coastal-grid-story__media{min-height:20rem}
      .coastal-grid-story__content{padding:2rem 1.25rem 2.35rem}
    }
    @media(prefers-reduced-motion:reduce){.coastal-grid-story__media img,.coastal-grid-commerce .product-card__figure img{transition:none!important}}
  `,document.head.append(style);const buildStory=()=>{const story=document.createElement("article");return story.className="coastal-grid-story",story.dataset.coastalGridRoom=room,story.dataset.manufacturerScene=room==="living"?"living-lango-room":room==="dining"?"dining-point-breeze-lineage":room==="bedroom"?"bedroom-rio-vista-lineage":room==="office"?"office-lyncott":"outdoor-paradise-trail",story.innerHTML=`<div class="coastal-grid-story__media"><img src="${scene.image}" alt="${scene.alt}" loading="lazy" width="1800" height="1200"></div><div class="coastal-grid-story__content"><p class="coastal-grid-story__eyebrow">${scene.eyebrow}</p><h2>${scene.title}</h2><p class="coastal-grid-story__copy">${scene.copy}</p><a class="coastal-grid-story__link" href="${scene.href}">${scene.link}</a></div>`,story},mount=()=>{if(document.querySelector(".coastal-grid-story"))return!0;const grid=[...document.querySelectorAll('.product-list,.product-grid,[class*="product-list"]')].find(candidate=>[...candidate.children].filter(child=>child.matches?.("product-card,.product-card")||child.querySelector?.("product-card,.product-card")).length>=8);if(!grid)return!1;const cards=[...grid.children].filter(child=>child.matches?.("product-card,.product-card")||child.querySelector?.("product-card,.product-card")),anchor=cards[Math.min(8,cards.length-1)];return grid.insertBefore(buildStory(),anchor),!0};if(!mount()){const observer=new MutationObserver(()=>{mount()&&observer.disconnect()});observer.observe(document.documentElement,{childList:!0,subtree:!0})}})(),(()=>{if(window.coastalDescriptionDisclosureSyncV2)return;window.coastalDescriptionDisclosureSyncV2=!0;const connect=(root=document)=>root.querySelectorAll("details.coastal-description").forEach(details=>{const sync=()=>details.setAttribute("aria-expanded",details.open?"true":"false");sync(),!details.dataset.coastalDisclosureSyncV2&&(details.dataset.coastalDisclosureSyncV2="true",details.addEventListener("toggle",sync))});document.readyState==="loading"?document.addEventListener("DOMContentLoaded",()=>connect(),{once:!0}):connect(),document.addEventListener("shopify:section:load",event=>connect(event.target)),new MutationObserver(()=>connect()).observe(document.documentElement,{childList:!0,subtree:!0})})();
//# sourceMappingURL=/cdn/shop/t/4/assets/coastal-storefront-static-v1.js.map?v=99877471100751026631788669219

/* coastal-category-card-scenes-v4-restored */
(() => {
  if (window.coastalCategoryCardScenesV4Restored) return;
  window.coastalCategoryCardScenesV4Restored = true;
  const styleId = 'coastal-category-card-scenes-v4-restored-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = ".coastal-category-nav__media--scene {\n      background: #eee9e1 !important;\n      border: 0 !important;\n      padding: 0 !important;\n      overflow: hidden !important;\n      box-shadow: none !important;\n    }\n\n    .coastal-category-nav__image[data-coastal-category-scene='true'] {\n      display: block !important;\n      width: 100% !important;\n      height: 100% !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      border: 0 !important;\n      box-sizing: border-box !important;\n      object-fit: cover !important;\n      object-position: var(--coastal-category-scene-focus, center) !important;\n    }";
    document.head.append(style);
  }
})();

(() => {
      if (window.coastalCategoryCardScenesV1) return;
      window.coastalCategoryCardScenesV1 = true;

      const scenes = new Map(Object.entries({
        '/collections/living-room-sofas': {
          id: 'e3d93838-a4ee-45ea-86f9-b3282856c840',
          alt: 'Neutral sofa styled in a bright living room'
        },
        '/collections/living-room-sectionals': {
          id: 'a1712eb0-07b5-4865-bd4b-c46ed2556694',
          alt: 'Gray modular sectional in a spacious contemporary living room'
        },
        '/collections/living-room-loveseats': {
          id: '6e30f41d-bb9b-475f-b1aa-171f29ceded3',
          alt: 'Neutral loveseat styled in a light-filled living room'
        },
        '/collections/living-room-recliners': {
          id: 'ea724566-17b2-49db-832e-34cb2bab8bf5',
          alt: 'Upholstered recliner styled beside a lamp and accent table'
        },
        '/collections/living-room-chairs': {
          id: '457c3fd2-e225-422e-b6f4-0791b576963b',
          alt: 'Leather accent chair styled in a warm modern room'
        },
        '/collections/living-room-tables': {
          id: '6f80305b-7ab0-46d6-af89-ac23ab546ee2',
          alt: 'Lift-top coffee table styled with books and greenery'
        },
        '/collections/living-room-ottomans': {
          id: 'aa738cdf-d4b3-4a72-ba1d-e4ae1c07307d',
          alt: 'Oversized upholstered ottoman styled on a textured rug'
        },
        '/collections/tv-stands': {
          id: '295e6a41-1893-4d78-ad90-9638bf19df1c',
          alt: 'Two-tone TV stand styled in a finished living space'
        },
        '/collections/dining-room-sets': {
          id: 'e13bb1e9-958d-43a3-af31-c0f7db92f89c',
          alt: 'Relaxed dining room with a light farmhouse table and coordinated seating'
        },
        '/collections/dining-room-tables': {
          id: '8e4c1dcb-d151-4787-ac14-15d6590f63a8',
          alt: 'Warm wood dining table styled for gathering'
        },
        '/collections/dining-room-chairs': {
          id: 'fc98e8cd-fa7f-4946-be2a-00b76df571f5',
          alt: 'Pair of upholstered dining chairs styled in a bright room'
        },
        '/collections/dining-room-stools': {
          id: 'bfa66fdf-7cf4-4ed6-bbb2-fe1f2dbe099d',
          alt: 'Pair of upholstered bar stools styled by a window'
        },
        '/collections/dining-room?filter.p.product_type=Servers': {
          id: '59ff60e0-72c8-4b06-9ee6-003a46f0e504',
          alt: 'Dining room server styled with serving pieces and greenery'
        },
        '/collections/dining-room?filter.p.product_type=Display%20Cabinets': {
          id: 'c81eaf16-d281-491e-9f0c-b8b721b97b23',
          alt: 'Display cabinet styled with books, pottery and greenery'
        },
        '/collections/bedroom-beds': {
          id: '53fbc0cd-7dca-48cc-baca-a0524afdad76',
          alt: 'Modern wood bed styled in an airy adult bedroom'
        },
        '/collections/bedroom-sets': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Airy bedroom with a complete white furniture collection and layered bedding'
        },
        '/collections/bedroom-dresser-mirror': {
          id: 'c3c0854b-7de7-4f78-a140-ab8b431bdc46',
          alt: 'Warm neutral adult bedroom with an upholstered bed and coordinating dresser'
        },
        '/collections/bedroom-nightstands': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Bright bedroom with coordinated bedside tables and soft layered bedding'
        },
        '/collections/bedroom-chests': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Bright bedroom with a coordinated tall chest and white furniture collection'
        },
        '/collections/bedroom?filter.p.product_type=Storage%20Beds': {
          id: 'e48d6b62-c73d-4950-a888-f072a6550bcb',
          alt: 'Complete storage bed with a bookcase headboard styled in a bedroom'
        },
        '/collections/home-office-desks': {
          id: '8cfa6660-9e91-4dec-aa1e-e93de903212f',
          alt: 'Bright home office centered on a warm wood writing desk'
        },
        '/collections/bookcases': {
          id: '87be4340-ce08-4adf-9e95-0d9f123ec8b8',
          alt: 'Bright home office with open bookcases and an L-shaped desk'
        },
        '/collections/home-office-cabinets': {
          id: '8cfa6660-9e91-4dec-aa1e-e93de903212f',
          alt: 'Warm home office with open storage, a desk and practical organization'
        },
        '/collections/kids-teens-beds': {
          id: 'f34a8075-8173-4d91-b39b-43b7632cd192',
          alt: 'Twin storage bed styled in a bright youth bedroom'
        },
        '/collections/kids-teens-dresser-mirror': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Bright youth bedroom with a coordinated dresser and mirror'
        },
        '/collections/kids-teens-chests': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Bright youth bedroom with a coordinated tall storage chest'
        },
        '/collections/kids-teens-nightstands': {
          id: '3e231ca4-f277-45e0-9ca6-0fce1ba40221',
          alt: 'Bright youth bedroom with coordinated bedside storage'
        },
        '/collections/mattresses?filter.v.option.size=Twin': {
          id: 'b0bc1a94-7e58-455b-bd27-05b72adf09b9',
          alt: 'Twin mattress styled in a bright modern bedroom'
        },
        '/collections/mattresses?filter.v.option.size=Twin%20Long': {
          id: '4066254c-a906-49e1-8815-88d889c4bdd3',
          alt: 'Twin XL mattress styled in a calm contemporary bedroom'
        },
        '/collections/mattresses?filter.v.option.size=Full': {
          id: '68566a14-b8e2-48ba-ac7f-1ed54547df79',
          alt: 'Full mattress styled in a warm modern bedroom'
        },
        '/collections/mattresses?filter.v.option.size=Queen': {
          id: '68a555ad-ecc6-42a8-95d4-a6603bf57ae0',
          alt: 'Queen mattress styled in a restful contemporary bedroom'
        },
        '/collections/mattresses?filter.v.option.size=King': {
          id: '06da34bb-30fe-4700-be93-d88fb3491618',
          alt: 'King mattress styled in a bright neutral bedroom'
        },
        '/collections/mattresses?filter.v.option.size=California%20King': {
          id: '506dfad4-987f-45fd-a84f-c032c1fbbb80',
          alt: 'California king mattress styled in an airy bedroom'
        },
        '/collections/mattresses?filter.p.product_type=Hybrid%20Mattresses': {
          id: '5bb36409-0906-4dc1-973f-6826e3286bb1',
          alt: 'Hybrid mattress styled in a light-filled bedroom'
        },
        '/collections/mattresses?filter.p.product_type=Memory%20Foam%20Mattresses': {
          id: 'ec176480-ccfc-4953-99b2-fc878d1cb86f',
          alt: 'Memory foam mattress styled in a soft neutral bedroom'
        },
        '/collections/rugs': {
          id: '2534f196-3fbf-4db6-b3b6-2060c83cf628',
          alt: 'Textured area rug styled beneath a neutral sofa'
        },
        '/collections/lighting': {
          id: '7bb60902-cfbb-4da8-a7db-332142432d27',
          alt: 'Table lamp styled on a bedside table in a bright room'
        },
        '/collections/mirrors': {
          id: '894003f1-4daa-464f-816c-0354b80f6bd3',
          alt: 'Wood-framed mirror styled above a storage cabinet'
        },
        '/collections/wall-art': {
          id: '69554077-241d-4c1d-be38-417ecdc780f6',
          alt: 'Coastal wall art styled in a finished living space'
        },
        '/collections/pillows': {
          id: 'c645ceba-f6f3-452e-8a2f-a3e53cc61a5f',
          alt: 'Patterned accent pillow styled on an upholstered chair'
        },
        '/collections/planters-vases': {
          id: 'c92bae6a-d2e0-4202-8646-f1b95b45d5a0',
          alt: 'Planter set styled with greenery in a bright room'
        },
        '/collections/storage-organizers': {
          id: 'eb14d92b-fb9a-4dd3-9854-0da3b030bd23',
          alt: 'Magazine organizer styled with reading material on a textured rug'
        },
        '/collections/clocks': {
          id: '6bd002d3-8874-4064-96a7-962047f9e776',
          alt: 'Wall clock styled above a console in a finished room'
        },
        '/collections/outdoor?filter.p.product_type=Chair%20Sets': {
          id: 'a51f84d5-5db5-4f8f-a4df-d6699c3e886d',
          alt: 'Coordinated outdoor seating set styled on a bright patio'
        },
        '/collections/outdoor?filter.p.product_type=Sofas': {
          id: 'eb8449fe-a0b4-4024-bcd3-e5964f8c104c',
          alt: 'Outdoor sofa collection styled in a relaxed patio setting'
        },
        '/collections/outdoor?filter.p.product_type=Lounge%20Chairs': {
          id: '01ba7163-0ef6-49b8-99bc-3839adce98d7',
          alt: 'Pair of outdoor chaise lounges styled beside a pool'
        },
        '/collections/outdoor?filter.p.product_type=Dining%20Tables': {
          id: '6f22e127-efb7-4cef-9eb7-ded9d7ac4ee8',
          alt: 'Outdoor dining table styled for a patio gathering'
        },
        '/collections/outdoor?filter.p.product_type=Coffee%20Tables': {
          id: '77ba0055-7095-4f36-90a5-956fd74f8ef5',
          alt: 'Outdoor coffee table styled beside a pool'
        },
        '/collections/outdoor?filter.p.product_type=Fire%20Pits': {
          id: '1f2bd5d2-542a-4d06-b224-a565a28b5471',
          alt: 'Lit outdoor fire pit table styled on a garden patio'
        }
      }));

      const keyForCard = (card) => {
        const url = new URL(card.getAttribute('href'), window.location.origin);
        return `${url.pathname}${url.search}`;
      };

      const apply = (root = document) => {
        root.querySelectorAll('.coastal-category-nav__card[href]').forEach((card) => {
          const scene = scenes.get(keyForCard(card));
          const image = card.querySelector('.coastal-category-nav__image');
          if (!scene || !image || image.dataset.coastalCategorySceneId === scene.id) return;

          const source = `/cdn/shop/files/${scene.id}.jpg`;
          image.src = `${source}?width=900`;
          image.srcset = [300, 450, 600, 900, 1200]
            .map((width) => `${source}?width=${width} ${width}w`)
            .join(', ');
          image.alt = scene.alt;
          image.width = 900;
          image.height = 600;
          image.dataset.coastalCategoryScene = 'true';
          image.dataset.coastalCategorySceneId = scene.id;
          image.closest('.coastal-category-nav__media')?.classList.add('coastal-category-nav__media--scene');
        });
      };

      let timer;
      const schedule = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => apply(), 80);
      };

      document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', () => apply(), { once: true })
        : apply();
      document.addEventListener('shopify:section:load', schedule);
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    })();

/* coastal-room-finder-v1 */
(() => {
  if (window.coastalRoomFinderV1) return;
  window.coastalRoomFinderV1 = true;

  const finderUrl = '/pages/design-help?finder=living-room';
  const consultationUrl = '/pages/contact?topic=design-help&from=room-finder';
  const resultStorageKey = 'coastal-room-finder-result-v1';
  const savedPlanStorageKey = 'coastal-room-finder-saved-plan-v1';
  const rotationStorageKey = 'coastal-room-finder-rotation-v1';

  const choices = {
    space: {
      compact: { label: 'Compact', copy: 'Apartment, den or a room under roughly 12 × 12 ft.' },
      standard: { label: 'Standard', copy: 'A typical living room with room for a sofa and accent seating.' },
      generous: { label: 'Generous', copy: 'An open or larger room with space for sectional seating.' },
    },
    style: {
      quiet: { label: 'Quiet Coastal', copy: 'Airy neutrals, pale finishes and an easy, collected feeling.' },
      warm: { label: 'Warm Natural', copy: 'Layered woods, grounded color and relaxed texture.' },
      casual: { label: 'Casual Contemporary', copy: 'Clean silhouettes, comfortable upholstery and practical pieces.' },
    },
    household: {
      everyday: { label: 'Everyday living', copy: 'A comfortable room for reading, relaxing and daily use.', guidance: 'Favor easy circulation and leave comfortable reach between seating and tables.' },
      family: { label: 'Family & pets', copy: 'Durability, easy living and generous comfort come first.', guidance: 'Confirm upholstery care, performance-fabric details and clear walking paths before ordering.' },
      entertaining: { label: 'Entertaining', copy: 'Conversation-friendly seating and flexible surfaces.', guidance: 'Arrange seating for conversation and preserve flexible surfaces for drinks, lighting and serving.' },
      rental: { label: 'Vacation rental', copy: 'Welcoming, versatile pieces selected for broad appeal.', guidance: 'Prioritize straightforward care, flexible placement and pieces that are easy for guests to understand.' },
    },
    budget: {
      essential: { label: 'Up to $2,500', copy: 'Start with four foundational pieces and add layers over time.', index: 0 },
      considered: { label: '$2,500–$5,000 room budget', copy: 'Balance the four starting pieces with room for lighting, rugs and accents.', index: 1 },
      elevated: { label: '$5,000+ room budget', copy: 'Use elevated room-building options while keeping the first recommendation focused.', index: 2 },
    },
    timing: {
      browsing: { label: 'Just exploring', copy: 'Save a direction and return when the timing is right.', guidance: 'Save this direction, compare dimensions and revisit availability when you are closer to ordering.' },
      season: { label: 'Within 1–3 months', copy: 'Start narrowing pieces and confirming measurements.', guidance: 'Confirm room and access measurements now, then recheck price and availability before ordering.' },
      soon: { label: 'As soon as possible', copy: 'Prioritize pieces that are available when you review them.', guidance: 'These pieces are available now; confirm measurements and current delivery timing before checkout.' },
    },
  };

  const steps = [
    { key: 'space', eyebrow: 'Your space', title: 'How much room are we working with?' },
    { key: 'style', eyebrow: 'Your direction', title: 'Which room feels most like you?' },
    { key: 'household', eyebrow: 'How you live', title: 'What does this room need to handle?' },
    { key: 'budget', eyebrow: 'Your investment', title: 'What furniture budget should guide the plan?' },
    { key: 'timing', eyebrow: 'Your timing', title: 'When would you like the room to come together?' },
  ];

  const plans = {
    quiet: {
      title: 'Quiet Coastal Living Room',
      eyebrow: 'Light, calm and comfortably collected',
      copy: 'A soft neutral foundation with natural texture and restrained contrast—coastal without feeling themed.',
      searchUrl: '/collections/living-room',
      products: {
        seating: {
          compact: ['maitelynn-loveseat-chalk', 'bridgepoint-loveseat', 'aviemore-loveseat'],
          standard: ['lango-sofa-chaise-jute', 'maitelynn-sofa-chalk', 'bridgepoint-sofa'],
          generous: ['lango-living-room-set', 'aviemore-sectional-set', 'lango-queen-sofa-chaise-sleeper-jute'],
        },
        accent: ['wychworth-accent-chair-gray-natural', 'lango-chair-jute', 'maitelynn-chair-chalk'],
        cocktail: ['robbinsdale-table', 'realyn-oval-cocktail-table-white-brown', 'montia-square-cocktail-table-multi'],
        side: ['camdill-round-end-table-light-brown-white', 'realyn-round-end-table-white-brown', 'montia-square-end-table-multi'],
      },
    },
    warm: {
      title: 'Warm Natural Living Room',
      eyebrow: 'Grounded woods and relaxed texture',
      copy: 'An inviting room built around warm finishes, comfortable seating and pieces that feel collected over time.',
      searchUrl: '/collections/living-room',
      products: {
        seating: {
          compact: ['bridgepoint-loveseat', 'aviemore-loveseat', 'maitelynn-loveseat-chalk'],
          standard: ['bridgepoint-sofa', 'willowbend-sofa', 'lango-sofa-chaise-jute'],
          generous: ['bridgepoint-sectional', 'willowbend-sectional', 'donelson-creek-sectional'],
        },
        accent: ['goda-accent-chair', 'bridgepoint-chair-moss', 'garronmont-accent-chair-caramel'],
        cocktail: ['brendalhouse-rectangular-table', 'breckington-rectangle-cocktail-table-dark-brown', 'dressonni-rectangular-cocktail-table-brown'],
        side: ['noraluna-round-table', 'brinstead-chair-side-end-table-light-brown', 'jorielyn-square-table'],
      },
    },
    casual: {
      title: 'Casual Contemporary Living Room',
      eyebrow: 'Clean, comfortable and ready for real life',
      copy: 'A practical, flexible room with approachable silhouettes and a balance of comfort, storage and easy movement.',
      searchUrl: '/collections/living-room',
      products: {
        seating: {
          compact: ['simplejoy-sofa', 'bridgepoint-loveseat', 'aviemore-sofa'],
          standard: ['hartside-sofa-frosted', 'tallow-creek-sofa-shadow', 'lango-sofa-chaise-jute'],
          generous: ['bales-sectional', 'bealton-sectional', 'donelson-creek-sectional'],
        },
        accent: ['bixler-showood-accent-chair', 'morrilton-next-gen-nuvella-accent-chair-natural-charcoal', 'tallow-creek-chair-and-a-half-shadow'],
        cocktail: ['breckington-rectangle-cocktail-table-dark-brown', 'breckington-cocktail-table-with-storage-dark-brown', 'torlanta-lift-top-cocktail-table-brown'],
        side: ['watson-square-end-table-dark-brown', 'breckington-rectangular-2-door-end-table-dark-brown', 'roanhowe-rectangular-end-table-brown'],
      },
    },
  };

  const roleLabels = {
    seating: 'Seating anchor',
    accent: 'Accent chair',
    cocktail: 'Coffee table',
    side: 'End table',
  };

  const ensureStyles = () => {
    if (document.getElementById('coastal-room-finder-v1-styles')) return;
    const style = document.createElement('style');
    style.id = 'coastal-room-finder-v1-styles';
    style.textContent = `
      .coastal-room-finder-launch {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: clamp(1.5rem, 4vw, 4rem);
        align-items: center;
        margin: clamp(2rem, 5vw, 4rem) 0;
        padding: clamp(1.5rem, 5vw, 4.5rem);
        background: #e9e2d8;
        color: #272522;
        overflow-wrap: normal;
        word-break: normal;
      }
      .coastal-room-finder-launch__eyebrow,
      .coastal-room-finder__eyebrow,
      .coastal-room-finder-result__eyebrow {
        margin: 0 0 .65rem;
        font-size: .72rem;
        font-weight: 700;
        letter-spacing: .14em;
        text-transform: uppercase;
      }
      .coastal-room-finder-launch h2 {
        max-width: none;
        margin: 0;
        font-family: var(--heading-font-family);
        font-size: clamp(2rem, 3.25vw, 3.25rem);
        font-weight: 400;
        line-height: 1.03;
        letter-spacing: -.035em;
        overflow-wrap: normal;
        word-break: normal;
        hyphens: none;
      }
      .coastal-room-finder-launch__copy {
        max-width: 42rem;
        margin: 1rem 0 0;
        line-height: 1.7;
      }
      .coastal-room-finder-launch__aside {
        min-width: 0;
        padding-top: 1.25rem;
        padding-left: 0;
        border-top: 1px solid rgba(39, 37, 34, .18);
        border-left: 0;
      }
      .coastal-room-finder-launch__aside p {
        margin: 0;
        line-height: 1.65;
      }
      .coastal-room-finder__button,
      .coastal-room-finder__link-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        padding: .85rem 1.25rem;
        border: 1px solid #272522;
        border-radius: 0;
        background: #272522 !important;
        background-image: none !important;
        color: #fff !important;
        font: inherit;
        font-size: .9rem;
        font-weight: 650;
        line-height: 1.2;
        text-decoration: none;
        cursor: pointer;
      }
      .coastal-room-finder__link-button::before,
      .coastal-room-finder__link-button::after {
        display: none !important;
        content: none !important;
      }
      .coastal-room-finder__button--secondary,
      .coastal-room-finder__link-button--secondary {
        background: transparent !important;
        color: #272522 !important;
      }
      .coastal-room-finder__button:hover,
      .coastal-room-finder__button:focus-visible,
      .coastal-room-finder__link-button:hover,
      .coastal-room-finder__link-button:focus-visible {
        opacity: .74;
      }
      .coastal-room-finder-launch .coastal-room-finder__link-button {
        margin-top: 1.25rem;
      }
      .coastal-room-finder {
        max-width: 1180px;
        margin: clamp(1.5rem, 4vw, 3rem) auto clamp(3rem, 7vw, 6rem);
        padding-inline: max(1.25rem, 4vw);
        color: #272522;
      }
      .coastal-room-finder__header {
        display: flex;
        justify-content: space-between;
        gap: 1.25rem;
        align-items: flex-end;
        margin-bottom: clamp(1.5rem, 4vw, 3rem);
      }
      .coastal-room-finder__header h1 {
        max-width: 15ch;
        margin: 0;
        font-family: var(--heading-font-family);
        font-size: clamp(2.35rem, 5.5vw, 5rem);
        font-weight: 400;
        line-height: .98;
        letter-spacing: -.045em;
      }
      .coastal-room-finder__intro {
        max-width: 38rem;
        margin: .9rem 0 0;
        line-height: 1.7;
      }
      .coastal-room-finder__progress-wrap {
        min-width: min(18rem, 35vw);
      }
      .coastal-room-finder__progress-label {
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: .5rem;
        font-size: .78rem;
        font-weight: 650;
      }
      .coastal-room-finder__progress {
        height: 3px;
        overflow: hidden;
        background: rgba(39, 37, 34, .15);
      }
      .coastal-room-finder__progress span {
        display: block;
        height: 100%;
        background: #272522;
        transition: width .25s ease;
      }
      .coastal-room-finder__stage {
        padding: clamp(1.5rem, 5vw, 4rem);
        background: #f2eee7;
      }
      .coastal-room-finder__stage h2 {
        max-width: 20ch;
        margin: 0 0 clamp(1.5rem, 3vw, 2.5rem);
        font-family: var(--heading-font-family);
        font-size: clamp(1.9rem, 4vw, 3.25rem);
        font-weight: 400;
        line-height: 1.05;
        letter-spacing: -.03em;
      }
      .coastal-room-finder__options {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
        margin: 0;
        padding: 0;
        border: 0;
      }
      .coastal-room-finder__option {
        position: relative;
        display: block;
        min-height: 9.5rem;
        padding: 1.25rem;
        border: 1px solid rgba(39, 37, 34, .2);
        background: rgba(255, 255, 255, .5);
        cursor: pointer;
      }
      .coastal-room-finder__option:has(input:checked) {
        border-color: #272522;
        background: #fff;
        box-shadow: inset 0 0 0 1px #272522;
      }
      .coastal-room-finder__option input {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 1.1rem;
        height: 1.1rem;
        accent-color: #272522;
      }
      .coastal-room-finder__option strong {
        display: block;
        max-width: calc(100% - 2rem);
        margin-bottom: .5rem;
        font-size: 1.03rem;
      }
      .coastal-room-finder__option span {
        display: block;
        font-size: .88rem;
        line-height: 1.55;
        opacity: .78;
      }
      .coastal-room-finder__actions {
        display: flex;
        justify-content: space-between;
        gap: .75rem;
        margin-top: 1.5rem;
      }
      .coastal-room-finder__actions-group {
        display: flex;
        gap: .75rem;
      }
      .coastal-room-finder__error {
        margin: 1rem 0 0;
        color: #8a2d21;
        font-size: .88rem;
      }
      .coastal-room-finder-result {
        display: grid;
        gap: clamp(1.5rem, 4vw, 3rem);
      }
      .coastal-room-finder-result__heading {
        display: grid;
        grid-template-columns: minmax(0, 1.25fr) minmax(17rem, .75fr);
        gap: clamp(1.5rem, 5vw, 5rem);
        align-items: end;
      }
      .coastal-room-finder-result__heading h2 {
        max-width: 17ch;
        margin: 0;
      }
      .coastal-room-finder-result__heading-copy {
        margin: 0;
        line-height: 1.7;
      }
      .coastal-room-finder-result__summary {
        display: flex;
        flex-wrap: wrap;
        gap: .5rem 1rem;
        margin: 0;
        padding: .9rem 0;
        border-block: 1px solid rgba(39, 37, 34, .16);
        list-style: none;
        font-size: .8rem;
      }
      .coastal-room-finder-result__summary strong {
        margin-right: .3rem;
      }
      .coastal-room-finder-result__guidance {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
      }
      .coastal-room-finder-result__guidance p {
        margin: 0;
        padding: 1rem 1.1rem;
        background: rgba(222, 211, 196, .48);
        font-size: .86rem;
        line-height: 1.55;
      }
      .coastal-room-finder-result__guidance strong {
        display: block;
        margin-bottom: .25rem;
        font-size: .7rem;
        letter-spacing: .1em;
        text-transform: uppercase;
      }
      .coastal-room-finder-result__products {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 1rem;
      }
      .coastal-room-finder-product {
        min-width: 0;
      }
      .coastal-room-finder-product__media {
        display: block;
        aspect-ratio: 1 / 1;
        overflow: hidden;
        background: #fff;
      }
      .coastal-room-finder-product__media img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform .25s ease;
      }
      .coastal-room-finder-product__media:hover img {
        transform: scale(1.02);
      }
      .coastal-room-finder-product__role {
        margin: .85rem 0 .25rem;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .11em;
        text-transform: uppercase;
        opacity: .68;
      }
      .coastal-room-finder-product h3 {
        margin: 0;
        font-size: .95rem;
        line-height: 1.35;
      }
      .coastal-room-finder-product h3 a {
        color: inherit;
        text-decoration: none;
      }
      .coastal-room-finder-product__price {
        margin: .35rem 0 0;
        font-size: .88rem;
      }
      .coastal-room-finder-result__total {
        display: flex;
        justify-content: space-between;
        gap: 1.5rem;
        align-items: flex-start;
        padding: 1.25rem 0;
        border-top: 1px solid rgba(39, 37, 34, .16);
      }
      .coastal-room-finder-result__total p {
        max-width: 42rem;
        margin: 0;
        font-size: .84rem;
        line-height: 1.55;
        opacity: .75;
      }
      .coastal-room-finder-result__total strong {
        white-space: nowrap;
        font-size: 1.1rem;
      }
      .coastal-room-finder-fit {
        padding: clamp(1.25rem, 3vw, 2rem);
        border: 1px solid rgba(39, 37, 34, .18);
        background: rgba(255, 255, 255, .48);
      }
      .coastal-room-finder-fit__heading {
        display: flex;
        justify-content: space-between;
        gap: 1.5rem;
        align-items: center;
      }
      .coastal-room-finder-fit__heading h3 {
        margin: 0 0 .35rem;
        font-family: var(--heading-font-family);
        font-size: clamp(1.45rem, 2.5vw, 2rem);
        font-weight: 400;
      }
      .coastal-room-finder-fit__heading p,
      .coastal-room-finder-fit__note {
        margin: 0;
        font-size: .86rem;
        line-height: 1.55;
        opacity: .78;
      }
      .coastal-room-finder-fit__form {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
        margin-top: 1.5rem;
      }
      .coastal-room-finder-fit__field {
        display: grid;
        gap: .4rem;
        min-width: 0;
      }
      .coastal-room-finder-fit__field label,
      .coastal-room-finder-fit__field legend {
        font-size: .76rem;
        font-weight: 700;
        letter-spacing: .04em;
      }
      .coastal-room-finder-fit__field input,
      .coastal-room-finder-fit__field select {
        width: 100%;
        min-height: 48px;
        padding: .7rem .8rem;
        border: 1px solid rgba(39, 37, 34, .35);
        border-radius: 0;
        background: #fff;
        color: #272522;
        font: inherit;
      }
      .coastal-room-finder-fit__field--wide,
      .coastal-room-finder-fit__actions,
      .coastal-room-finder-fit__assessment {
        grid-column: 1 / -1;
      }
      .coastal-room-finder-fit__actions {
        display: flex;
        justify-content: flex-end;
      }
      .coastal-room-finder-fit__assessment {
        padding: 1rem 1.1rem;
        background: #e9e2d8;
      }
      .coastal-room-finder-fit__assessment h4 {
        margin: 0 0 .5rem;
        font-size: 1rem;
      }
      .coastal-room-finder-fit__assessment ul {
        margin: 0;
        padding-left: 1.1rem;
        font-size: .86rem;
        line-height: 1.55;
      }
      .coastal-room-finder-result__consult {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 1.5rem;
        align-items: center;
        padding: clamp(1.5rem, 4vw, 3rem);
        background: #ded3c4;
      }
      .coastal-room-finder-result__consult h3 {
        margin: 0 0 .4rem;
        font-family: var(--heading-font-family);
        font-size: clamp(1.5rem, 3vw, 2.2rem);
        font-weight: 400;
      }
      .coastal-room-finder-result__consult p {
        max-width: 42rem;
        margin: 0;
        line-height: 1.6;
      }
      .coastal-room-finder__loading {
        padding: clamp(3rem, 8vw, 7rem) 1rem;
        text-align: center;
      }
      .coastal-room-finder__loading p {
        margin: .75rem 0 0;
      }
      @media (max-width: 1399px) {
        .coastal-room-finder-launch,
        .coastal-room-finder-result__heading {
          grid-template-columns: 1fr;
        }
        .coastal-room-finder-launch__aside {
          padding-top: 1.25rem;
          padding-left: 0;
          border-top: 1px solid rgba(39, 37, 34, .18);
          border-left: 0;
        }
        .coastal-room-finder__header {
          display: grid;
        }
        .coastal-room-finder__progress-wrap {
          min-width: 0;
        }
        .coastal-room-finder-result__products {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .coastal-room-finder-result__guidance {
          grid-template-columns: 1fr;
        }
      }
      @media (max-width: 699px) {
        .coastal-room-finder {
          margin-top: 1rem;
          padding-inline: 1rem;
        }
        .coastal-room-finder__stage {
          padding: 1.25rem;
        }
        .coastal-room-finder__options {
          grid-template-columns: 1fr;
        }
        .coastal-room-finder__option {
          min-height: 0;
          padding: 1rem 2.75rem 1rem 1rem;
        }
        .coastal-room-finder__actions,
        .coastal-room-finder__actions-group,
        .coastal-room-finder-result__consult,
        .coastal-room-finder-fit__heading,
        .coastal-room-finder-fit__form {
          display: grid;
          grid-template-columns: 1fr;
        }
        .coastal-room-finder-fit__field--wide,
        .coastal-room-finder-fit__actions,
        .coastal-room-finder-fit__assessment {
          grid-column: auto;
        }
        .coastal-room-finder__actions-group {
          width: 100%;
        }
        .coastal-room-finder__button,
        .coastal-room-finder__link-button {
          width: 100%;
        }
        .coastal-room-finder-result__products {
          gap: 1.25rem .75rem;
        }
        .coastal-room-finder-result__total {
          display: grid;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .coastal-room-finder__progress span,
        .coastal-room-finder-product__media img {
          transition: none;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const emitEvent = (event, detail = {}) => {
    const payload = { event, pathway: 'coastal-room-finder', page_path: window.location.pathname, ...detail };
    document.dispatchEvent(new CustomEvent('coastal:room-finder', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  };

  const safeStorage = {
    get(storage, key) {
      try { return storage.getItem(key); } catch { return null; }
    },
    set(storage, key, value) {
      try { storage.setItem(key, value); return true; } catch { return false; }
    },
  };

  const mountLaunchCard = () => {
    if (window.location.pathname !== '/pages/design-help') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('finder') === 'living-room') return;
    const main = document.querySelector('main');
    if (!main || main.querySelector('[data-coastal-room-finder-launch]')) return;
    const pathwaySteps = main.querySelector('[data-coastal-design-pathway="steps"]');
    const anchor = pathwaySteps || main.querySelector('[data-coastal-design-pathway="intro"]');
    if (!anchor) return;
    const section = document.createElement('section');
    section.className = 'coastal-room-finder-launch';
    section.dataset.coastalRoomFinderLaunch = 'living-room';
    section.setAttribute('aria-labelledby', 'coastal-room-finder-launch-title');
    section.innerHTML = `
      <div>
        <p class="coastal-room-finder-launch__eyebrow">New · Living Room Finder</p>
        <h2 id="coastal-room-finder-launch-title">Find a room direction before you browse.</h2>
        <p class="coastal-room-finder-launch__copy">Answer five quick questions and receive a coordinated living-room starting point built from current Coastal products.</p>
      </div>
      <div class="coastal-room-finder-launch__aside">
        <p>No account required. Your answers stay on this device unless you choose to send the plan to a Coastal designer.</p>
        <a class="coastal-room-finder__link-button" href="${finderUrl}">Find my living room</a>
      </div>
    `;
    anchor.insertAdjacentElement('afterend', section);
  };

  const normalizeProduct = (product, role) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const availableVariants = variants.filter((variant) => variant.available);
    if (!product.available || !availableVariants.length) return null;
    const chosenVariant = availableVariants.reduce((best, variant) => {
      if (!best) return variant;
      return Number(variant.price) < Number(best.price) ? variant : best;
    }, null);
    const rawImage = product.featured_image || product.images?.[0];
    const image = typeof rawImage === 'string' ? rawImage : rawImage?.src;
    return {
      role,
      handle: product.handle,
      title: product.title,
      image,
      price: Number(chosenVariant?.price ?? product.price ?? 0),
      variantId: chosenVariant?.id || null,
      url: `/products/${encodeURIComponent(product.handle)}`,
    };
  };

  const fetchProduct = async (handle, role) => {
    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
      if (!response.ok) return null;
      return normalizeProduct(await response.json(), role);
    } catch {
      return null;
    }
  };

  const nextRotation = (answers) => {
    const path = [answers.style, answers.space, answers.budget].join(':');
    let rotations = {};
    try { rotations = JSON.parse(safeStorage.get(localStorage, rotationStorageKey) || '{}'); } catch { rotations = {}; }
    const current = Number(rotations[path] || 0);
    rotations[path] = current + 1;
    safeStorage.set(localStorage, rotationStorageKey, JSON.stringify(rotations));
    return current;
  };

  const orderedCandidates = (candidates, preferredIndex, rotation) => {
    const normalized = candidates.map((candidate, index) => typeof candidate === 'string'
      ? { handle: candidate, tier: index }
      : candidate);
    const groups = [0, 1, 2]
      .sort((a, b) => Math.abs(a - preferredIndex) - Math.abs(b - preferredIndex))
      .flatMap((tier) => {
        const group = normalized.filter((candidate) => candidate.tier === tier);
        if (!group.length) return [];
        const start = rotation % group.length;
        return [...group.slice(start), ...group.slice(0, start)];
      });
    return [...groups, ...normalized.filter((candidate) => !groups.includes(candidate))];
  };

  const resolveRole = async (handles, role, preferredIndex, rotation) => {
    for (const candidate of orderedCandidates(handles, preferredIndex, rotation)) {
      const product = await fetchProduct(candidate.handle, role);
      if (product) return product;
    }
    return null;
  };

  const resolveProducts = async (answers) => {
    const plan = plans[answers.style];
    const preferredIndex = choices.budget[answers.budget].index;
    const rotation = nextRotation(answers);
    const expanded = window.coastalRoomFinderRegistryV2?.paths?.[answers.style];
    const roleCandidates = expanded ? {
      seating: expanded.seating[answers.space], accent: expanded.accent,
      cocktail: expanded.cocktail, side: expanded.side,
    } : {
      seating: plan.products.seating[answers.space], accent: plan.products.accent,
      cocktail: plan.products.cocktail, side: plan.products.side,
    };
    const products = await Promise.all(
      Object.entries(roleCandidates).map(([role, handles]) => resolveRole(handles, role, preferredIndex, rotation))
    );
    return products.filter(Boolean);
  };

  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 2,
  }).format(cents / 100);

  const finderSummary = (answers, products) => ({
    createdAt: new Date().toISOString(),
    rotationPolicy: 'controlled-path-rotation-v1',
    room: 'Living room',
    answers,
    labels: Object.fromEntries(Object.entries(answers).map(([key, value]) => [key, choices[key][value].label])),
    plan: { key: answers.style, title: plans[answers.style].title },
    products: products.map(({ role, handle, title, url, price, variantId }) => ({ role, handle, title, url, price, variantId })),
  });

  const assessRoomFit = ({ roomLength, roomWidth, doorwayWidth, seatingCapacity, focalPoint, photoPrepared }, answers) => {
    const length = Number(roomLength);
    const width = Number(roomWidth);
    const doorway = Number(doorwayWidth);
    const area = length * width;
    const notes = [];
    const concerns = [];
    if (Math.min(length, width) < 10) concerns.push('One room dimension is under 10 ft, so circulation around full-depth seating may be tight.');
    if (area < 120 && answers.space !== 'compact') concerns.push('The measured area is smaller than the selected room-size direction. Recheck the Compact path before ordering.');
    if (area >= 260 && answers.space === 'compact') notes.push('The room may support a larger seating plan than the Compact path shows.');
    if (doorway < 32) concerns.push('The narrowest access point is under 32 in. Verify packaged dimensions, turns, stairs and delivery clearance for every item.');
    else notes.push('The reported doorway is at least 32 in, but the complete delivery path still needs to be checked.');
    if (Number(seatingCapacity) >= 5 && answers.space === 'compact') concerns.push('The requested seating capacity may be difficult to achieve comfortably with the Compact plan.');
    if (focalPoint === 'both') notes.push('Plan sight lines carefully so seating can address both the TV and fireplace without blocking circulation.');
    if (focalPoint === 'tv') notes.push('Confirm viewing distance and screen height before fixing the seating position.');
    if (focalPoint === 'fireplace') notes.push('Maintain required fireplace clearances and avoid placing upholstery too close to heat.');
    if (focalPoint === 'neither') notes.push('A conversation-centered layout can remain flexible; preserve a clear main walking path.');
    if (photoPrepared) notes.push('A room photo or sketch was selected locally. It was not uploaded; keep it ready for the designer conversation.');
    notes.push('Allow roughly 30–36 in for primary walkways and verify each product’s dimensions on its product page.');
    return {
      roomLength: length, roomWidth: width, roomArea: Number(area.toFixed(1)), doorwayWidth: doorway,
      seatingCapacity: String(seatingCapacity), focalPoint, photoPrepared: Boolean(photoPrepared),
      status: concerns.length ? 'review-recommended' : 'promising-start', concerns, notes,
      disclaimer: 'Planning guidance only. This does not guarantee product, room or delivery-path fit.',
    };
  };

  const saveForDesigner = (summary) => {
    safeStorage.set(sessionStorage, resultStorageKey, JSON.stringify(summary));
    emitEvent('room_finder_designer_handoff', { room: summary.room, style: summary.plan.key });
    window.location.href = consultationUrl;
  };

  const renderProduct = (product) => `
    <article class="coastal-room-finder-product">
      <a class="coastal-room-finder-product__media" href="${product.url}">
        ${product.image ? `<img src="${product.image}" alt="${product.title.replaceAll('"', '&quot;')}" loading="lazy">` : ''}
      </a>
      <p class="coastal-room-finder-product__role">${roleLabels[product.role]}</p>
      <h3><a href="${product.url}">${product.title}</a></h3>
      <p class="coastal-room-finder-product__price">From ${money(product.price)}</p>
    </article>
  `;

  const renderResult = (root, answers, products) => {
    const plan = plans[answers.style];
    let summary = finderSummary(answers, products);
    const total = products.reduce((sum, product) => sum + product.price, 0);
    root.innerHTML = `
      <section class="coastal-room-finder__stage coastal-room-finder-result" aria-labelledby="coastal-room-finder-result-title">
        <div class="coastal-room-finder-result__heading">
          <div>
            <p class="coastal-room-finder-result__eyebrow">${plan.eyebrow}</p>
            <h2 id="coastal-room-finder-result-title">${plan.title}</h2>
          </div>
          <p class="coastal-room-finder-result__heading-copy">${plan.copy} This is a curated starting point—not a guarantee that every piece fits your room. Confirm measurements and current availability before ordering.</p>
        </div>
        <ul class="coastal-room-finder-result__summary" aria-label="Your room finder selections">
          <li><strong>Space:</strong>${choices.space[answers.space].label}</li>
          <li><strong>Lifestyle:</strong>${choices.household[answers.household].label}</li>
          <li><strong>Budget:</strong>${choices.budget[answers.budget].label}</li>
          <li><strong>Timing:</strong>${choices.timing[answers.timing].label}</li>
        </ul>
        <div class="coastal-room-finder-result__guidance" aria-label="Guidance for your room">
          <p><strong>How to use the room</strong>${choices.household[answers.household].guidance}</p>
          <p><strong>Recommended next step</strong>${choices.timing[answers.timing].guidance}</p>
        </div>
        <div class="coastal-room-finder-result__products">
          ${products.length ? products.map(renderProduct).join('') : `<p>We could not confirm suitable available products right now. A Coastal designer can still help build the room.</p>`}
        </div>
        ${products.length ? `
          <div class="coastal-room-finder-result__total">
            <p>This estimate covers the four displayed starting pieces and may be below your overall room budget. Delivery, taxes, options, rugs, lighting and accessories are not included. Product pages remain the final source for price and availability.</p>
            <strong>Estimated total ${money(total)}</strong>
          </div>
        ` : ''}
        <section class="coastal-room-finder-fit" aria-labelledby="coastal-room-finder-fit-title">
          <div class="coastal-room-finder-fit__heading">
            <div>
              <h3 id="coastal-room-finder-fit-title">Check the room before you order.</h3>
              <p>Add a few approximate measurements to reveal likely scale, circulation and delivery-access concerns.</p>
            </div>
            <button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-fit-toggle aria-expanded="false">Check room fit</button>
          </div>
          <form class="coastal-room-finder-fit__form" data-room-finder-fit-form hidden>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-room-length">Room length (feet)</label>
              <input id="coastal-room-length" name="roomLength" type="number" min="6" max="100" step="0.1" inputmode="decimal" required>
            </div>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-room-width">Room width (feet)</label>
              <input id="coastal-room-width" name="roomWidth" type="number" min="6" max="100" step="0.1" inputmode="decimal" required>
            </div>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-doorway-width">Narrowest doorway or hallway (inches)</label>
              <input id="coastal-doorway-width" name="doorwayWidth" type="number" min="20" max="120" step="0.25" inputmode="decimal" required>
            </div>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-seating-capacity">Preferred seating capacity</label>
              <select id="coastal-seating-capacity" name="seatingCapacity" required>
                <option value="">Choose one</option><option value="2">2 people</option><option value="3">3 people</option><option value="4">4 people</option><option value="5">5 people</option><option value="6">6 or more people</option>
              </select>
            </div>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-focal-point">Primary focal point</label>
              <select id="coastal-focal-point" name="focalPoint" required>
                <option value="">Choose one</option><option value="tv">TV</option><option value="fireplace">Fireplace</option><option value="both">TV and fireplace</option><option value="neither">Conversation / no fixed focal point</option>
              </select>
            </div>
            <div class="coastal-room-finder-fit__field">
              <label for="coastal-room-photo">Optional room photo or sketch</label>
              <input id="coastal-room-photo" name="roomPhoto" type="file" accept="image/*">
            </div>
            <p class="coastal-room-finder-fit__note coastal-room-finder-fit__field--wide">Your image stays on this device and is not uploaded. Keep it available if you send the plan to a Coastal designer.</p>
            <div class="coastal-room-finder-fit__actions">
              <button class="coastal-room-finder__button" type="submit">Review my measurements</button>
            </div>
            <div class="coastal-room-finder-fit__assessment" data-room-finder-fit-assessment hidden aria-live="polite"></div>
          </form>
        </section>
        <div class="coastal-room-finder-result__consult">
          <div>
            <h3>Want this adapted to your actual room?</h3>
            <p>Send the plan with your photos and measurements. Your selected direction and product links will travel with the inquiry.</p>
          </div>
          <button class="coastal-room-finder__button" type="button" data-room-finder-consult>Send to a designer</button>
        </div>
        <div class="coastal-room-finder__actions">
          <button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-restart>Start over</button>
          <div class="coastal-room-finder__actions-group">
            <button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-save>Save this plan</button>
            <a class="coastal-room-finder__link-button coastal-room-finder__link-button--secondary" href="${plan.searchUrl}">Browse living room</a>
          </div>
        </div>
        <p class="coastal-room-finder__error" hidden data-room-finder-status aria-live="polite"></p>
      </section>
    `;
    const fitToggle = root.querySelector('[data-room-finder-fit-toggle]');
    const fitForm = root.querySelector('[data-room-finder-fit-form]');
    fitToggle?.addEventListener('click', () => {
      const expanded = fitToggle.getAttribute('aria-expanded') === 'true';
      fitToggle.setAttribute('aria-expanded', String(!expanded));
      fitToggle.textContent = expanded ? 'Check room fit' : 'Hide fit check';
      fitForm.hidden = expanded;
      if (!expanded) fitForm.querySelector('input')?.focus({ preventScroll: true });
    });
    fitForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!fitForm.reportValidity()) return;
      const data = new FormData(fitForm);
      const fitCheck = assessRoomFit({
        roomLength: data.get('roomLength'), roomWidth: data.get('roomWidth'), doorwayWidth: data.get('doorwayWidth'),
        seatingCapacity: data.get('seatingCapacity'), focalPoint: data.get('focalPoint'),
        photoPrepared: Boolean(fitForm.elements.roomPhoto?.files?.length),
      }, answers);
      summary = { ...summary, fitCheck };
      const assessment = fitForm.querySelector('[data-room-finder-fit-assessment]');
      assessment.hidden = false;
      assessment.innerHTML = `
        <h4>${fitCheck.concerns.length ? 'A designer review is recommended.' : 'These measurements are a promising starting point.'}</h4>
        <ul>${[...fitCheck.concerns, ...fitCheck.notes].map((note) => `<li>${note}</li>`).join('')}</ul>
        <p class="coastal-room-finder-fit__note">${fitCheck.disclaimer}</p>
      `;
      emitEvent('room_finder_fit_check', { status: fitCheck.status, concern_count: fitCheck.concerns.length });
    });
    root.querySelector('[data-room-finder-consult]')?.addEventListener('click', () => saveForDesigner(summary));
    root.querySelector('[data-room-finder-restart]')?.addEventListener('click', () => {
      emitEvent('room_finder_restart', { from: 'result' });
      mountFinder(root.closest('.coastal-room-finder'), true);
    });
    root.querySelector('[data-room-finder-save]')?.addEventListener('click', (event) => {
      const saved = safeStorage.set(localStorage, savedPlanStorageKey, JSON.stringify(summary));
      const status = root.querySelector('[data-room-finder-status]');
      event.currentTarget.textContent = saved ? 'Plan saved on this device' : 'Could not save on this device';
      if (status) {
        status.hidden = false;
        status.textContent = saved ? 'Your room direction has been saved on this device.' : 'Your browser prevented this plan from being saved.';
      }
      emitEvent('room_finder_plan_save', { room: summary.room, style: summary.plan.key, saved });
    });
    emitEvent('room_finder_result_view', { room: summary.room, style: summary.plan.key, product_count: products.length });
  };

  const renderStep = (root, state) => {
    const step = steps[state.index];
    const options = choices[step.key];
    const progress = ((state.index + 1) / steps.length) * 100;
    root.innerHTML = `
      <div class="coastal-room-finder__header">
        <div>
          <p class="coastal-room-finder__eyebrow">Living Room Finder</p>
          <h1>Build a room that feels like you.</h1>
          <p class="coastal-room-finder__intro">Five quick questions will create a coordinated starting point from current Coastal products.</p>
        </div>
        <div class="coastal-room-finder__progress-wrap">
          <div class="coastal-room-finder__progress-label"><span>Question ${state.index + 1} of ${steps.length}</span><span>${Math.round(progress)}%</span></div>
          <div class="coastal-room-finder__progress" role="progressbar" aria-label="Room finder progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span style="width:${progress}%"></span></div>
        </div>
      </div>
      <section class="coastal-room-finder__stage" aria-labelledby="coastal-room-finder-step-title">
        <p class="coastal-room-finder__eyebrow">${step.eyebrow}</p>
        <h2 id="coastal-room-finder-step-title">${step.title}</h2>
        <fieldset class="coastal-room-finder__options">
          <legend class="sr-only">${step.title}</legend>
          ${Object.entries(options).map(([value, option]) => `
            <label class="coastal-room-finder__option">
              <input type="radio" name="coastal-room-finder-${step.key}" value="${value}" ${state.answers[step.key] === value ? 'checked' : ''}>
              <strong>${option.label}</strong>
              <span>${option.copy}</span>
            </label>
          `).join('')}
        </fieldset>
        <p class="coastal-room-finder__error" hidden data-room-finder-error role="alert">Choose one option to continue.</p>
        <div class="coastal-room-finder__actions">
          ${state.index > 0 ? '<button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-back>Back</button>' : '<span></span>'}
          <button class="coastal-room-finder__button" type="button" data-room-finder-next>${state.index === steps.length - 1 ? 'Build my room direction' : 'Continue'}</button>
        </div>
      </section>
    `;
    root.querySelector('[data-room-finder-back]')?.addEventListener('click', () => {
      state.index -= 1;
      renderStep(root, state);
    });
    root.querySelector('[data-room-finder-next]')?.addEventListener('click', async (event) => {
      const selected = root.querySelector(`input[name="coastal-room-finder-${step.key}"]:checked`);
      const error = root.querySelector('[data-room-finder-error]');
      if (!selected) {
        if (error) error.hidden = false;
        return;
      }
      state.answers[step.key] = selected.value;
      emitEvent('room_finder_step_complete', { step: step.key, step_number: state.index + 1 });
      if (state.index < steps.length - 1) {
        state.index += 1;
        renderStep(root, state);
        root.querySelector('input')?.focus({ preventScroll: true });
        root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      event.currentTarget.disabled = true;
      root.innerHTML = '<div class="coastal-room-finder__stage coastal-room-finder__loading" role="status"><strong>Building your room direction…</strong><p>Checking the recommended pieces against current storefront availability.</p></div>';
      const products = await resolveProducts(state.answers);
      renderResult(root, state.answers, products);
      root.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  };

  const mountFinder = (existingRoot, reset = false) => {
    if (window.location.pathname !== '/pages/design-help') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('finder') !== 'living-room') return;
    const main = document.querySelector('main');
    if (!main) return;
    const root = existingRoot || main.querySelector('.coastal-room-finder') || document.createElement('div');
    if (!existingRoot && !root.isConnected) {
      root.className = 'coastal-room-finder';
      root.dataset.coastalRoomFinder = 'living-room';
      main.prepend(root);
      [...main.children].forEach((child) => {
        if (child !== root && !child.closest?.('.coastal-room-finder')) child.hidden = true;
      });
    }
    const initialAnswers = reset ? {} : {};
    renderStep(root, { index: 0, answers: initialAnswers });
    emitEvent('room_finder_start', { room: 'Living room' });
  };

  const enhanceConsultationHandoff = () => {
    if (window.location.pathname !== '/pages/contact') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('from') !== 'room-finder') return;
    const raw = safeStorage.get(sessionStorage, resultStorageKey);
    if (!raw) return;
    let summary;
    try { summary = JSON.parse(raw); } catch { return; }
    const form = document.querySelector('main form[action*="/contact"]:has(textarea)');
    if (!form || form.querySelector('[data-coastal-room-finder-context]')) return;
    const fit = summary.fitCheck || {};
    const roomName = String(summary.room || 'Room').trim();
    const roomFinderName = `${roomName} Finder`;
    const accessWidth = fit.accessWidth ?? fit.doorwayWidth;
    const answerLabel = (key) => summary.labels?.[key] || summary.answers?.[key] || '';
    const productUrl = (product) => String(product.url || '').startsWith('http')
      ? product.url
      : `${window.location.origin}${product.url || ''}`;
    const priority = fit.priorityLabel || fit.seatingCapacity || '';
    const values = {
      'Room finder room': roomName,
      'Room finder result': summary.plan?.title,
      'Room finder style': answerLabel('style'),
      'Room finder space': answerLabel('space'),
      'Room finder lifestyle': answerLabel('household'),
      'Room finder budget': answerLabel('budget'),
      'Room finder timing': answerLabel('timing'),
      'Room finder products': (summary.products || []).map((product) => `${product.title}: ${productUrl(product)}`).join('\n'),
      'Room measurements': fit.roomLength && fit.roomWidth ? `${fit.roomLength} ft × ${fit.roomWidth} ft${fit.roomArea ? ` (${fit.roomArea} sq ft)` : ''}` : '',
      'Narrowest access point': accessWidth ? `${accessWidth} in` : '',
      'Planning priority': priority,
      'Room focal point': fit.focalPoint,
      'Fit check status': fit.status,
      'Fit check concerns': (fit.concerns || []).join('\n'),
      'Fit check notes': (fit.notes || []).join('\n'),
      'Fit check disclaimer': fit.disclaimer,
    };
    Object.entries(values).forEach(([name, value]) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `contact[${name}]`;
      input.value = value;
      input.defaultValue = value;
      input.setAttribute('value', value);
      input.dataset.coastalRoomFinderContext = name;
      form.appendChild(input);
    });
    const message = form.querySelector('textarea');
    if (message && !message.value.trim()) {
      const measurementLine = fit.roomLength && fit.roomWidth
        ? `My ${roomName.toLowerCase()} is approximately ${fit.roomLength} ft × ${fit.roomWidth} ft${accessWidth ? `, with a ${accessWidth} in narrowest access point` : ''}.`
        : 'I will add my measurements below.';
      const priorityLine = priority ? `\nMy planning priority is: ${priority}.` : '';
      const concernLine = fit.concerns?.length ? `\nThe fit check flagged ${fit.concerns.length} item${fit.concerns.length === 1 ? '' : 's'} for designer review.` : '';
      const photoLine = fit.photoPrepared ? '\nI also have a room photo or sketch ready to share.' : '';
      message.value = `I used the ${roomFinderName} and would like help adapting the ${summary.plan?.title || 'recommended direction'} to my room.\n\n${measurementLine}${priorityLine}${concernLine}${photoLine}\n\nMy questions and product preferences:`;
    }
    const dimensionsInput = form.querySelector('#coastal-design-dimensions');
    if (dimensionsInput && fit.roomLength && fit.roomWidth && !dimensionsInput.value) dimensionsInput.value = `${fit.roomLength} ft × ${fit.roomWidth} ft`;
    const roomTypeInput = form.querySelector('#coastal-design-room-type');
    if (roomTypeInput && !roomTypeInput.value) {
      const matchingOption = [...roomTypeInput.options].find((option) => option.textContent.trim().toLowerCase() === roomName.toLowerCase());
      if (matchingOption) roomTypeInput.value = matchingOption.value;
    }
    const productsInput = form.querySelector('#coastal-design-products');
    if (productsInput && !productsInput.value) productsInput.value = (summary.products || []).map((product) => product.title).join(', ');
    safeStorage.set(sessionStorage, resultStorageKey, JSON.stringify({ ...summary, handedOffAt: new Date().toISOString() }));
  };

  const connect = () => {
    ensureStyles();
    mountLaunchCard();
    mountFinder();
    enhanceConsultationHandoff();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();

/* coastal-experience-suite-loader-v1 */
(() => {
  if (window.coastalExperienceSuiteLoaderV1) return;
  window.coastalExperienceSuiteLoaderV1 = true;
  const current = document.currentScript?.src;
  if (!current) return;
  const script = document.createElement('script');
  const suiteUrl = new URL('coastal-experience-suite-v1.js', current);
  suiteUrl.search = new URL(current).search;
  suiteUrl.searchParams.set('coastal_suite_revision', '20260908-room-projects-v1');
  script.src = suiteUrl.href;
  script.defer = true;
  document.head.appendChild(script);
})();
